export default __webpack_public_path__ + "static/media/me3_ECAP_Achievements_Icon.11c23b34.svg";